<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Review Homework">
      <v-container v-if="homework!==''">
        <v-row key="1">
          <v-col cols="6" md="6" sm="6">
            By
            <strong>{{homework.studentHomeWorks[0].studentAdmission.studentEnrollment.studentName}}</strong>
            <p>
              Class: {{homework.studentClass.name}} <br>
              Section: {{homework.studentSection.name}} <br>
              {{homework.date}}
            </p>
          </v-col>
          <v-col cols="6" md="6" sm="6">
            <div id="status" :class="getColor(homework.studentHomeWorks[0].approvalStatus)">
              {{ homework.studentHomeWorks[0].approvalStatus }}
            </div>
          </v-col>
        </v-row>

        <div class="homework-description" v-html="homework.homeWork">
        </div>
        <h4 class="mt-3 title-uploads">Teacher uploads</h4>
        <v-divider class=" my-0 " />
        <v-row>
          <v-col class="text-truncate" cols="2" md="2"
            v-for="path in homework.studentSubjectDairyDocuments" :key="path.id">
            <a :href="path.signedUrl" target="_blank">
              <v-icon>mdi-file-document-multiple-outline</v-icon> {{fileName(path.urlKey)}}
            </a>
          </v-col>
        </v-row>
        <h4 class="mt-4 title-uploads">Student uploads</h4>
        <v-divider class=" my-0 " />
        <v-row>
          <v-col cols="2" md="2" class="text-truncate"
            v-for="path in homework.studentHomeWorks[0].studentHomeWorkDocumentMaps" :key="path.id">
            <a :href="path.signedUrl" target="_blank">
              <v-icon>mdi-file-document-multiple-outline</v-icon> {{fileName(path.urlKey)}}
            </a>
          </v-col>
        </v-row>
      </v-container>
      <v-card-subtitle v-if="homework===''" class="d-flex justify-center">No Data Available
      </v-card-subtitle>
      <v-col>
        <div class="text-right">
          <v-btn color="primary" @click="toggleModal" class="px-2 ml-1 ma-1" min-width="0" large>
            <v-icon color="white" small>mdi-pencil</v-icon>
            <span class="ml-1">Review</span>
          </v-btn>
        </div>
      </v-col>
    </material-card>
    <!-- Loader Start -->
    <loading-icon :value="isLoading" />
    <!-- Loader End -->
    <!--Review Modal start-->
    <b-modal :width="500" :active="modalOk" :on-cancel="
        () => {
          modalOk = false
        }
      ">
      <div class="card">
        <div class="card-content">
          <section class="modal-card-body">
            <v-col cols="12" md="12">
              <label class="font-weight-medium body-2">
                Review Summary
                <span class="requir error--text">*</span>
              </label>
              <v-textarea rows="3" placeholder="Review summary" clearable
                clear-icon="mdi-close-circle" v-model.trim="formData.reviewSummary" maxlength="200"
                counter="200"> </v-textarea>
            </v-col>
            <v-col cols="12" md="6">
              <v-checkbox label="Mark as complete" v-model="formData.approvalStatus"></v-checkbox>
            </v-col>
          </section>
          <footer class="modal-card-foot">
            <button class="button" type="button" @click="hideModal">Cancel</button>
            <button class="button is-primary" @click="addReviewSummary">Save</button>
          </footer>
        </div>
      </div>
    </b-modal>
    <!-- Review modal end-->
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import moment from 'moment'

export default {
  name: 'viewHomework',
  components: { MaterialCard },
  created () {
    this.getHomework()
  },
  data: function () {
    return {
      isLoading: true,
      homework: '',
      modalOk: false,
      formData: {
        reviewSummary: '',
        approvalStatus: false
      }
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {},
  methods: {
    getHomework: async function (alert = false) {
      try {
        this.homework = ''
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/communication/getstudenthomeworkDetails`, {
          params: { subjectDairyID: this.$route.params.subjectId, studentID: this.$route.params.studentId }
        })
        this.homework = data
        this.homework.date = moment(this.homework.date).format('LL')
        this.formData.approvalStatus = this.homework.studentHomeWorks[0].approvalStatus === 'Reviewed'
        this.formData.reviewSummary = this.homework.studentHomeWorks[0].reviewSummary || ''
        if (alert) {
          this.$buefy.toast.open({
            message: 'Successfully updated the review.',
            type: 'is-success',
            duration: 5000
          })
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$buefy.toast.open({
          message: errorMessage,
          type: 'is-danger',
          duration: 4000
        })
      }
    },
    fileName (file) {
      return file.split('/')[file.split('/').length - 1]
    },
    getColor (status) {
      if (status === 'Reviewed') return 'v-green font-weight-bold'
      else if (status === 'Not Reviewed') return 'v-error font-weight-bold'
      else if (status === 'Not Submitted') return 'v-warning font-weight-bold'
      else return 'v-secondary '
    },
    addReviewSummary: async function () {
      if (this.formData.reviewSummary !== '') {
        this.isLoading = true
        await http.post(`${constants.API_URL}/api/communication/addHomeWorkReview/${this.homework.studentHomeWorks[0].id}`, {
          reviewSummary: this.formData.reviewSummary,
          approvalStatus: this.formData.approvalStatus ? 'Reviewed' : 'Not Reviewed'
        })
        this.modalOk = false
        this.isLoading = false
        this.getHomework(true)
      } else {
        this.isLoading = false
        this.$buefy.toast.open({
          message: 'Please fill review summary field.',
          type: 'is-danger',
          duration: 4000
        })
      }
    },
    toggleModal: function () {
      this.modalOk = true
    },
    hideModal: function () {
      this.modalOk = false
    }
  }
}
</script>
<style scoped>
#status {
  text-align: right;
}
.homework-description {
  border: solid rgb(223 179 196) 1px;
}
.title-uploads {
  font-weight: 600;
}
</style>
